export enum Alignment {
  START = "START",
  CENTER = "CENTER",
  END = "END",
}

export enum ALIGNMENT {
  START = 0,
  CENTER = 1,
  END = 2,
}
